module.exports = require("./fr-HT.d.ts");